import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IUser } from '@shared/auth/auth.models';
import { environment } from '@env/environment';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
  }), 
  withCredentials: true
};

@Injectable()
export class UserService {
  
  private apiUser: string = environment.privateApi + 'User/';  
  private apiAdmin: string = environment.privateApi + 'UserAdministration/';

  constructor(private http: HttpClient) {}

  getUsers(): Observable<IUser[]> {
    return this.http.get<IUser[]>(environment.privateApi + 'UserAdministration/users' ,  { withCredentials: true });
  }

  getUser(username: string): Observable<IUser> {
    return this.http.get<IUser>(environment.privateApi + 'UserAdministration/user/' + username ,  { withCredentials: true });
  }

  removeUser(username: string): Observable<boolean> {
    return this.http.get<boolean>(environment.privateApi + 'UserAdministration/user/remove/' + username,  { withCredentials: true });
  }

  findUser(filter: string) : Observable<IUser> {
    return this.http.get<IUser>(environment.privateApi + 'UserAdministration/user/find/' + filter,  { withCredentials: true });
  }

  getRoles() : Observable<string[]> {
    return this.http.get<string[]>(environment.privateApi + 'UserAdministration/roles' ,  { withCredentials: true });
  }

  public addUser(user: IUser) : Observable<any> {
    return this.http.post<any>(environment.privateApi + 'UserAdministration/user/add', user, httpOptions);
  }

  public saveUser(user: IUser) : Observable<any> {
    return this.http.post<any>(environment.privateApi + 'UserAdministration/user/save', user, httpOptions);
  }

  public getUserRolesByEmail(email: string) : Observable<string[]> {
    return this.http.get<string[]>(this.apiUser + 'userRoles/' + email,  { withCredentials: true });
  }
  
  public testInfo() : Observable<any> {
    return this.http.get<any>(environment.publicApi + 'Application/info',  { withCredentials: true });
  }
}
